import * as z from 'zod'

import type { ItemDetailedSearchModalFormVO } from './type'

import i18n from '@/lib/i18n'
import {
  currencyRangeValidation,
  dateRangeValidation,
  arrayStringLengthValidation,
} from '@/utils/validation'

export const panels = {
  main: {
    title: i18n.t('item.detailedSearch.title'),
    showClose: true,
    showBack: false,
  },
  category: {
    title: i18n.t('item.detailedSearch.categorySelect'),
    showClose: false,
    showBack: true,
  },
  brand: {
    title: i18n.t('item.detailedSearch.brandSelect'),
    showClose: false,
    showBack: true,
  },
}

export const UPDATE_COUNT_INTERVAL_MILLISECOND = 1000

const MAX_LENGTH = {
  retailPrice: 999999999,
  salonPrice: 999999999,
  brandCodes: 1000,
  categoryIds: 1000,
  keywords: 1000,
}

export const schema = z.object({
  keywords: z
    .string()
    .max(
      MAX_LENGTH.keywords,
      i18n.t('item.validation.maxLength', { max: MAX_LENGTH.keywords })
    )
    .optional(),
  categoryIds: z
    .array(z.number())
    .refine(arrayStringLengthValidation(MAX_LENGTH.categoryIds), {
      message: i18n.t('item.validation.categoryMaxExceeded'),
    })
    .optional(),
  brandCodes: z
    .array(z.string())
    .refine(arrayStringLengthValidation(MAX_LENGTH.brandCodes), {
      message: i18n.t('item.validation.brandMaxExceeded'),
    })
    .optional(),
  salonPrice: z
    .object({
      lower: z
        .number()
        .nonnegative()
        .max(
          MAX_LENGTH.salonPrice,
          i18n.t('item.validation.max', { max: MAX_LENGTH.salonPrice })
        )
        .optional(),
      upper: z
        .number()
        .nonnegative()
        .max(
          MAX_LENGTH.salonPrice,
          i18n.t('item.validation.max', { max: MAX_LENGTH.salonPrice })
        )
        .optional(),
    })
    .refine(currencyRangeValidation, {
      path: ['lower'],
      message: i18n.t('item.validation.invalidRange'),
    })
    .optional(),
  retailPrice: z
    .object({
      lower: z
        .number()
        .nonnegative()
        .max(
          MAX_LENGTH.retailPrice,
          i18n.t('item.validation.max', { max: MAX_LENGTH.retailPrice })
        )
        .optional(),
      upper: z
        .number()
        .nonnegative()
        .max(
          MAX_LENGTH.retailPrice,
          i18n.t('item.validation.max', { max: MAX_LENGTH.retailPrice })
        )
        .optional(),
    })
    .refine(currencyRangeValidation, {
      path: ['lower'],
      message: i18n.t('item.validation.invalidRange'),
    })
    .optional(),
  salesStart: z
    .object({
      from: z.string().optional(),
      to: z.string().optional(),
    })
    .refine(dateRangeValidation, {
      path: ['from'],
      message: i18n.t('item.validation.invalidRange'),
    })
    .optional(),
})

export const formDefaultValues: Partial<ItemDetailedSearchModalFormVO> = {
  keywords: undefined,
  salonPrice: { lower: undefined, upper: undefined },
  retailPrice: { lower: undefined, upper: undefined },
  salesStart: { from: undefined, to: undefined },
}
